var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHousing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21V4a1 1 0 00-1-1h-8a1 1 0 00-1 1v17M7.5 9h-4a1 1 0 00-1 1v11M22.5 21V10a1 1 0 00-1-1h-4M10 17h5M14 17v4M11 21v-4M10.5 10.5h4M10.5 13.5h4M10.5 7.5h4M5.5 13.5h2M5.5 17h2M17.5 13.5h2M17.5 17h2M23.5 21h-22",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgHousing;